import { DocumentFolderEntity, DocumentItemEntity, DocumentItemsListQueryEntity } from "../../../meta-data/app-meta-data.service";
import { StructuredDocumentSectionReferenceModel } from "../structured-content/models/structured-document-viewer.model";

export interface DocumentCardData {
    documentCardType: DocumentCardType;
    uniqueKey: string;
    newItem?: boolean;
    parentFolderId?: number;
    name?: string;
    groupOrder: number;
    initialPageNumber?: number;
    pageNumbers?: string;
    structuredDocumentReferences?: StructuredDocumentSectionReferenceModel[];
    
    documentItem?: DocumentItemsListQueryEntity;

    folderItem?: DocumentFolderEntity;
    folderKey?: string;
    folderPath?: string;
}

export enum DocumentCardType {
    documentItem = 'documentItem',
    folder = 'folder',
}
